import { FC } from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { HtmlRender } from '@base/snippets/HtmlRender';

type IModuleHeaderProps = {
    className?: string;
    title?: string;
    description?: string;
    center?: boolean;
};

export const ModuleHeader: FC<IModuleHeaderProps> = props => {
    const { className, title, description, center = false } = props;

    return (
        <div className={cn(className, styles.header, { [styles.center]: center })}>
            <div className={cn(styles.decoration, 'g-decoration')}/>

            <HtmlRender
                className={cn(styles.title, 'g-title g-font-ext')}
                tag={'h2'}
                html={title}
            />

            <HtmlRender
                className={cn(styles.desc, 'g-desc')}
                html={description}
            />
        </div>
    )
};
